import { supabase } from '../supabase.js'
import { readNcfdStatus } from './ncfdContract.js'

export async function fetchNcfdStatus({ signal } = {}) {
  const { data: { session } } = await supabase.auth.getSession()
  if (!session) throw new Error('Sign in to view NCFD status')
  const response = await fetch('/api/market-regime/ncfd', {
    headers: { Authorization: `Bearer ${session.access_token}` }, signal,
  })
  if (!response.ok) throw new Error('NCFD status unavailable')
  return readNcfdStatus(await response.json())
}

export async function streamNcfdSnapshots({signal,onSnapshot}) {
  const {data:{session}}=await supabase.auth.getSession()
  if(!session?.access_token)throw new Error('Sign in required')
  const response=await fetch('/api/market-regime/ncfd-stream',{
    headers:{Authorization:`Bearer ${session.access_token}`,Accept:'text/event-stream'},signal,
  })
  if(!response.ok||!response.headers.get('content-type')?.includes('text/event-stream')||!response.body)throw new Error('NCFD stream unavailable')
  const reader=response.body.getReader(),decoder=new TextDecoder()
  let buffer='',received=false
  try {
    while(true){
      const {value,done}=await reader.read();if(done)break
      buffer=(buffer+decoder.decode(value,{stream:true})).replace(/\r\n/g,'\n')
      if(buffer.length>32768)throw new Error('Invalid NCFD stream size')
      let boundary
      while((boundary=buffer.indexOf('\n\n'))!==-1){
        const frame=buffer.slice(0,boundary);buffer=buffer.slice(boundary+2)
        if(frame.split('\n').includes('event: unavailable'))throw new Error('NCFD feed interrupted')
        if(!frame.split('\n').includes('event: ncfd'))continue
        const body=frame.split('\n').filter(line=>line.startsWith('data:')).map(line=>line.slice(5).trimStart()).join('\n')
        const snapshot=readNcfdStatus(JSON.parse(body));received=true;onSnapshot(snapshot)
      }
    }
    if(!received)throw new Error('No NCFD snapshot')
  } finally {await reader.cancel().catch(()=>{});reader.releaseLock()}
}
